import React from "react";

const TableShimmer = () => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2 bg-white rounded-xl border border-gray-100 p-0 md:p-4 shadow-none md:shadow-sm">
        <div className="w-full flex items-center justify-between p-3 rounded-xl">
          {/* LEFT SIDE */}
          <div className="flex items-center gap-4 min-w-0">
            {/* Avatar */}
            <div className="h-10 w-10 md:h-12 md:w-12 rounded-xl shimmer flex-shrink-0" />

            {/* Name + Balance */}
            <div className="flex flex-col gap-2 min-w-[120px]">
              <div className="h-4 w-32 shimmer rounded-md" />
              <div className="h-3 w-20 shimmer rounded-md" />
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex items-center gap-2 ml-auto">
            <div className="h-9 w-9 rounded-full shimmer" />
            <div className="h-9 w-9 rounded-full shimmer" />
            <div className="h-9 w-9 rounded-full shimmer" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableShimmer;
